import { useQuery } from "@tanstack/react-query";
import axios from "axios";

export const useEpisodeGrowth = (accountID, showID) =>
    useQuery({
        queryKey: ["episode-growth", accountID, showID],
        queryFn: () =>
            axios.get(`/api/${ accountID }/metrics/shows/${ showID }/episode-growth`)
                .then(res => res.data)
    });
